










































































































import { Component, Emit, Prop, VModel, Vue } from 'vue-property-decorator';

import Icon from "../../../../../Icon/Icon.vue";
import { FilesWithPreviewToUpload, FileWithPreviewToUpload } from "../../logic/filesToUpload";
import { FileType } from "../../types";

@Component({
  data() {
    return {
      FileType
    }
  },
  components: {
    Icon
  }
})
export default class FilesListWithThumbnail extends Vue {
  @VModel() filesList!: FilesWithPreviewToUpload

  @Prop() selectedType!: FileType

  @Emit()
  selectThumbnail(item: FileWithPreviewToUpload, index: number) {
    return {
      item,
      index
    }
  }

  @Emit()
  uploadFiles() {
    return this.filesList
  }

  get iconType() {
    if (this.selectedType === FileType.Audio) {
      return 'play_arrow'
    } else if (this.selectedType === FileType.Document) {
      return 'insert_drive_file'
    } else {
      return ''
    }
  }

  changeSpoilerFileType(file: FileWithPreviewToUpload, index: number) {
    if (file.uploadInfo?.spoiler !== undefined && file.uploadInfo?.type !== undefined) {
      file.uploadInfo.spoiler = !file.uploadInfo.spoiler

      const { type } = file.uploadInfo

      if (type === FileType.Video) {
        file.uploadInfo.type = FileType.SpoilerVideo
      } else if (type === FileType.SpoilerVideo) {
        file.uploadInfo.type = FileType.Video
      } else if (type === FileType.Animation) {
        file.uploadInfo.type = FileType.SpoilerAnimation
      } else if (type === FileType.SpoilerAnimation) {
        file.uploadInfo.type = FileType.Animation
      }
    }
  }
}
